import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  TextField,
  IconButton,
  MenuItem,
  Modal,
  Skeleton,
  Autocomplete,
  Tooltip,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { headingStyle } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import { menuItemStyle, primaryBtn } from "../../style/AppointmentStyle";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import { showToast } from "../../utils/toastUtil";
import { Link, useNavigate } from "react-router-dom";
import { autoFocusOffWithOutBorder } from "../../style/PatinetFormStyle";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import json_icon from "../../assets/json_icon.svg";
import csv_icon from "../../assets/csv_icon.svg";
import CustomModal from "../CustomModal/CustomModal";
import PurchaseOrderDetails from "./PurchaseOrderDetails";
import EditPurchaseOrder from "./EditPurchaseOrder";
import NewPurchaseOrder from "./NewPurchaseOrder";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import UseFetchPurchaseOrder from "../../helper/UseFetchPurchaseOrder";
import {
  formattedDateWithoutBg,
  generateCSV,
  handleShowJson,
} from "../../utils/constantFunctions";
import { deletePurchaseOrder } from "../../connections/deleteApi";
import SupplierDetails from "./SupplierDetails";
import useDebounce from "../../hooks/UseDebounce";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import UseFetchSupplierList from "../../helper/UseFetchSupplierList";
import PurchaseItemsView from "./PurchaseItemsView";
import InwardSuppliesReport from "./InwardSuppliesReport";
import AiIcon from "../../../src/assets/ai-icon.png";
import SettingsBackupRestoreOutlinedIcon from "@mui/icons-material/SettingsBackupRestoreOutlined";
import ReturnPurchaseOrder from "./ReturnPurchaseOrder";
import AddPucharaseOrderFileScan from "./AddPucharaseOrderFileScan";

const PurchaseOrder = ({ onClose }) => {
  // console.log(medicines);
  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [editPurchaseOrderModal, setEditPurchaseOrderModal] = useState(false);
  const [newPurchaseOrderModal, setNewPurchaseOrderModal] = useState(false);
  const [returnPurchaseOrder, setReturnPurchaseOrder] = useState(false);
  const [supperDetailsModal, setSupperDetailsModal] = useState(false);
  const [puchaseOrderScanFile, setPuchaseOrderScanFile] = useState(false);
  const [viewMode, setViewMode] = useState("suppliers"); // "suppliers" | "medicines" | "inward_report"
  const [id, setId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [SupplierId, setSupplierId] = useState(null);
  const [selectSupplierId, setSelectSupplierId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filter, setFilter] = useState(false);
  const [goToPage, setGoToPage] = useState("");

  const [focus, setFocus] = useState(false);
  const [supplierInput, setSupplierInput] = useState(null);

  const debouncedInputSupplier = useDebounce(supplierInput, 800);

  // const [purchaseInput, setPurchaseInput] = useState(null);
  // const handlePurchaseChange = (e) => {
  //   // console.log('working', e);
  //   e.preventDefault();
  //   setPurchaseInput(e?.target?.value);
  // };

  // const debouncedInputPurchase = useDebounce(purchaseInput, 800);

  // console.log(supplierList, 'supplierList')
  const handleSupplierChange = (e) => {
    // console.log('working', e);
    e.preventDefault();
    setSupplierInput(e?.target?.value);
  };

  const { data: supplierList } = UseFetchSupplierList(
    1,
    10,
    debouncedInputSupplier,
  );

  const {
    data: purchaseOrderList,
    refetch,
    isFetching: isLoading,
  } = filter
      ? UseFetchPurchaseOrder(
        page,
        itemPerPage,
        selectSupplierId,
        startDate,
        endDate,
      )
      : UseFetchPurchaseOrder(page, itemPerPage, null);

  const totalRecords = purchaseOrderList?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage);

  //  useEffect(()=>{

  //  },[])
  // Handle Page Change

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    setDeleteModal(false);
    const res = await deletePurchaseOrder(id);
    // console.log(res);
    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    if (res?.status?.status) {
      refetch(page, itemPerPage);
    }
  };
  // console.log(purchaseOrderList)

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setSelectSupplierId(value);
  };

  // console.log(filter, 'filter')
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "relative",
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        {/* medicines (item-level) view overlays the suppliers list */}
        {viewMode === "medicines" && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              zIndex: 30,
              bgcolor: "background.paper",
              display: "flex",
              flexDirection: "column",
              borderRadius: "20px",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: "25px",
                pt: "12px",
                pb: "4px",
              }}
            >
              <Typography
                variant="heading_Large"
                fontWeight={700}
                sx={headingStyle}
              >
                Medicines Purchased
              </Typography>
              <IconButton onClick={onClose}>
                <CloseIcon size="small" sx={{ color: "red" }} />
              </IconButton>
            </Box>
            <PurchaseItemsView
              onSwitchToSuppliers={() => setViewMode("suppliers")}
            />
          </Box>
        )}

        {/* Inward Supplies Report overlay */}
        {viewMode === "inward_report" && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              zIndex: 30,
              bgcolor: "background.paper",
              display: "flex",
              flexDirection: "column",
              borderRadius: "20px",
              overflow: "hidden",
            }}
          >
            <InwardSuppliesReport
              onClose={onClose}
              onSwitchToSuppliers={() => setViewMode("suppliers")}
            />
          </Box>
        )}

        {/* //modals for delete and filter */}
        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          sx={{
            position: "absolute",
            top: "25%",
            width: "450px",
            margin: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: 3.6,
              boxShadow: 24,
              p: 4.5,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography textAlign={"center"}>Are you sure?</Typography>
              <Typography textAlign={"center"}>
                You want to delete these selected purchase orders?
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "flex",
                gap: "25px",
                width: "max-content",
                margin: "auto",
                marginTop: "40px",
              }}
            >
              <Button
                sx={{
                  backgroundColor: "#FF392B",
                  color: "white",
                  border: "",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "red",
                  },
                }}
                onClick={() => handleDelete(id)}
              >
                Delete
              </Button>
              <Button
                onClick={() => setDeleteModal(false)}
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  border: "2px solid #FF392B",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={filterModal}
          onClose={() => {
            setFilterModal(false);
            setSupplierId(null);
            setStartDate(null);
            setEndDate(null);
            setFilter(false);
          }}
          sx={{
            position: "absolute",
            top: "14%",
            width: "340px",
            margin: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: "20px",
              boxShadow: 24,
              p: 1,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Grid container spacing={2} sx={{ padding: "9px" }}>
              <Box sx={{ width: "100%", marginY: 1 }}>
                <Typography fontWeight={"600"} textAlign={"center"}>
                  Filters
                </Typography>
              </Box>

              <Grid item xs={12}>
                <Typography variant="subTitle116px">Supplier</Typography>
                <Autocomplete
                  onFocus={() => setFocus(true)}
                  onBlur={() => setFocus(false)}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "15px",
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                      borderRadius: "15px",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "15px",
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiInputBase-input": {
                      padding: "2px 8px",
                    },
                    "& .MuiAutocomplete-inputRoot": {
                      padding: "2px 8px", // Remove extra padding around input
                    },
                    // padding:'0px',
                    borderRadius: "15px",
                    backgroundColor: "#F7F7FF",
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                  options={supplierList?.payload?.suppliers || []}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    supplierList?.payload?.suppliers?.find(
                      (supplier) => supplier?.id === selectSupplierId,
                    ) || null
                  }
                  onChange={(e, newValue) => {
                    handleFormChange({
                      target: {
                        name: "suppliers",
                        value: newValue ? newValue.id : "",
                      },
                    });
                    handleFormChange({
                      target: {
                        name: "supplier_id",
                        value: newValue?.id || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Supplier"
                      onChange={handleSupplierChange}
                    // error={!!errors.suppliers}
                    />
                  )}
                  renderOption={(props, option) => (
                    <MenuItem
                      {...props}
                      key={option.id}
                      value={option.id}
                      sx={menuItemStyle}
                    >
                      {option.name}
                    </MenuItem>
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>

              {/* Purchase Date */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Purchase Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Department Selection */}
              {/* <Grid item xs={12}>
                <Typography variant="subTitle116px">Department</Typography>
                <Select
                  fullWidth
                  defaultValue=""
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "#F7F7FF",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <MenuItem value="dept1">Department 1</MenuItem>
                  <MenuItem value="dept2">Department 2</MenuItem>
                  <MenuItem value="dept3">Department 3</MenuItem>
                </Select>
              </Grid> */}

              {/* Created At */}
              {/* <Grid item xs={12}>
                <Typography variant="subTitle116px">Created At</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid> */}

              {/* Buttons */}
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtnTeal, color: "white" }}
                  onClick={() => {
                    setFilter(true);
                    setPage(1);
                    setFilterModal(false);
                  }}
                >
                  Apply
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  onClick={() => {
                    setFilterModal(false);
                    setSelectSupplierId(null);
                    setStartDate(null);
                    setFilter(false);
                    setEndDate(null);
                  }}
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtn, color: "white", border: "none" }}
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CreditCardIcon
                sx={{
                  color: "neutral.navyBlue",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                Purchase Order
              </Typography>
            </Box>
            <IconButton sx={{ marginBottom: "2rem" }} onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Box
            mt={-1}
            mb={-1}
            marginLeft={-1}
            marginRight={-1}
            display="flex"
            justifyContent="space-between"
            // gap='40px'
            alignItems="center"
            position="sticky"
            paddingX="25px"
          >
            <Box sx={{ display: "flex", gap: 2 }}>
              <AddRoundedIcon
                onClick={() => setNewPurchaseOrderModal(true)}
                sx={{
                  backgroundColor: "#FFE7DC",
                  p: "4px",
                  width: "20px",
                  color: "#FF8D1E",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              />

              <Button
                onClick={() => setPuchaseOrderScanFile(true)}
                // variant="contained"
                sx={{
                  backgroundColor: "neutral.teal",
                  p: "0px",
                  paddingX: "0px",
                  // width: "px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "neutral.teal",
                    color: "neutral.teal",
                  },
                }}
              >
                <img src={AiIcon} width={20} alt="ai" />
              </Button>
              
              <Button
                onClick={() => setViewMode("medicines")}
                sx={{
                  fontSize: "12px",
                  textTransform: "none",
                  color: "#007A99",
                  border: "1px solid #007A99",
                  borderRadius: "8px",
                  px: "10px",
                  py: "2px",
                }}
              >
                Medicines view
              </Button>

              <Button
                onClick={() => {
                  setViewMode("inward_report")
                 
                }}
                sx={{
                  fontSize: "12px",
                  textTransform: "none",
                  color: "#007A99",
                  border: "1px solid #007A99",
                  borderRadius: "8px",
                  px: "10px",
                  py: "2px",
                }}
              >
               Item View
              </Button>
            </Box>

            {/* <Box sx={{ display: "flex", gap: 10 }}>
              {" "}
            
            </Box> */}

            <Box
              onClick={() => setFilterModal(true)}
              sx={{
                display: "flex",
                alignItems: "center",
                marginRight: "20px",
              }}
            >
              <IconButton>
                <TuneRoundedIcon size="small" sx={{ color: "#0067FF" }} />
              </IconButton>
              <Typography>Filters</Typography>
            </Box>

            {/* <Box>
              <TextField
                sx={{ ...autoFocusOffWithOutBorder }}
                type="text"
                className="form-control"
                placeholder="Search Supplier"
                value={purchaseInput}
                onChange={handlePurchaseChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box> */}
          </Box>

          <Grid item xs={12}>
            <TableContainer sx={{ mt: 2, width: "100%" }}>
              <Table sx={{ width: "100%" }}>
                <TableHead stickyHeader>
                  <TableRow sx={{ textAlign: "center" }}>
                    {/* <TableCell
                      variant="body1_text_bold"
                      sx={{
                        borderTopLeftRadius: "20px",

                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Checkbox />
                    </TableCell> */}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        //  paddingX:"4px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      Supplier
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        width: "130px",
                        paddingRight: "30px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Created at
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Updated at
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Purchase Date
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Grand Total
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Bill Type
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Department
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Bill No
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Paid
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                {isLoading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} sx={{ p: 0 }}>
                        <Box
                          sx={{
                            rowGap: 1.2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : purchaseOrderList &&
                  purchaseOrderList?.payload?.purchase_orders?.length > 0 ? (
                  <TableBody>
                    {/* { purchaseOrderList?.map(()=>{   
              <TableRow   sx={{...tableRowLab, textAlign: "center" , backgroundColor:"#F7F7FF" , borderBottom:"8px solid white" , borderTop:"2px solid white" }}>
                  <TableCell
                variant="subTitle116px" 
                  sx={{
                    borderTopLeftRadius:"20px",
                    borderBottomLeftRadius:"20px",
                  color: 'neutral.black',
                    p: "8px", 
                    textAlign: "center",
                  }}
                > 
                  <Checkbox/>
                </TableCell>
                <TableCell
                
                  sx={{
                  
                  color: 'neutral.black',
                    p: "8px", 
                    textAlign: "center",
                  }}
                >
                  <Typography variant="subTitle116px">1</Typography>

                </TableCell>
                <TableCell
                 variant="body1_text_bold" 
                 sx={{
                 color: 'neutral.black',
                   p: "8px",
                  //  paddingX:"4px",
                   textAlign: "center",
                   width: "200px",
                 }}
                >
                 
               <Link> <Typography  variant="subTitle116px">
                  Supplier   
                    </Typography> 
                    </Link>
                </TableCell>

                <TableCell  
                 
                  variant="body1_text_bold" 
                  sx={{
                    width: "130px",
                    paddingRight: "30px",
                  color: 'neutral.black',
                    p: "8px",
                    textAlign: "center",
                  }}
                >
                  <Box sx={{display:'flex' , flexDirection:'column'}}>
                    <Typography  variant="subTitle116px">08 nov 2024</Typography>
                    <Typography  variant="subTitle116px"> 19 :17 </Typography>
                  </Box>
                </TableCell>
                <TableCell
                 variant="body1_text_bold" 
                 sx={{
                 color: 'neutral.black',
                   p: "8px",
                   textAlign: "center",
                 }}
                >
                  <Box sx={{display:'flex' , flexDirection:'column'}}>
                    <Typography  variant="subTitle116px">08 nov 2024</Typography>
                    <Typography  variant="subTitle116px"> 19 :17 </Typography>
                  </Box>
                </TableCell>
                <TableCell
                 variant="body1_text_bold" 
                 sx={{
                 color: 'neutral.black',
                   p: "8px",
                   textAlign: "center",
                 }}
                >
                
                    <Typography  variant="subTitle116px">08 nov 2024</Typography>
                    
                </TableCell>

                <TableCell
                variant="body1_text_bold" 
                sx={{
                color: 'neutral.black',
                  p: "8px",
                  textAlign: "center",
                }}
                >
                
                <Typography   variant="subTitle116px"> &#8377;   9999</Typography>
                </TableCell>
                <TableCell
                 variant="body1_text_bold" 
                 sx={{
                 color: 'neutral.black',
                   p: "8px",
                   textAlign: "center",
                 }}
                >
                   <Typography  variant="subTitle116px"> credit</Typography>
                </TableCell>

                <TableCell
                 variant="body1_text_bold" 
                 sx={{
                 color: 'neutral.black',
                   p: "8px",
                   textAlign: "center",
                 }}
                >
                  
                  <Link> <Typography  variant="subTitle116px"> Pharmacy</Typography></Link>
                </TableCell>

                <TableCell
                 variant="body1_text_bold" 
                 sx={{
                 color: 'neutral.black',
                   p: "8px",
                   textAlign: "center",
                 }}
                >
                <Typography  variant="subTitle116px">232323</Typography>   
                </TableCell>

                <TableCell
                variant="body1_text_bold" 
                sx={{
                color: 'neutral.black',
                  p: "8px",
                  textAlign: "center",
                }}
                >
                  
                  <Typography  variant="subTitle116px" >  net Banking</Typography>
                </TableCell>

                <TableCell
               sx={{
                borderTopRightRadius:"20px",
                borderBottomRightRadius:'20px',
               }}
                
                >
                <Box sx={{display:'flex' , gap:'8px' , marginRight:"-8px"}}> 
                <RemoveRedEyeOutlinedIcon onClick={()=>setDetailsModal(true)} sx={{ backgroundColor:"#0067FF" , p:'2px' ,width:"20px", color:'white' , borderRadius:"8px" ,cursor:"pointer"}}/>
                <EditOutlinedIcon onClick={()=>{setEditPurchaseOrderModal(true)}}  sx={{ backgroundColor:"#FF8D1E" , p:'2px',  width:"20px", color:'white' , borderRadius:"8px" ,cursor:"pointer"}}/>
                <DeleteForeverOutlinedIcon onClick={()=>{setDeleteModal(true)}} sx={{backgroundColor:"#FF392B" ,p:'2px',  width:"18px", color:"white" , borderRadius:"8px" ,cursor:"pointer"}}/>

                    </Box>
              

                </TableCell>

              </TableRow>
               })} */}

                    {purchaseOrderList?.payload?.purchase_orders?.map(
                      (order, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            textAlign: "center",
                            backgroundColor: "neutral.blueShadeBg",
                            borderBottom: "8px solid white",
                            borderTop:
                              index === 0
                                ? "4px solid white"
                                : "2px solid white",
                            cursor: "pointer",
                          }}
                        >
                          {/* <TableCell
                            sx={{
                              textAlign: "center",
                              borderTopLeftRadius: "20px",
                              borderBottomLeftRadius: "20px",
                            }}
                          >
                            <Checkbox />
                          </TableCell> */}
                          <TableCell
                            sx={{
                              textAlign: "center",
                              borderTopLeftRadius: "20px",
                              borderBottomLeftRadius: "20px",
                            }}
                          >
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {order.id}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Link
                              onClick={() => {
                                setSupperDetailsModal(true);
                                setSupplierId(order?.supplier?.id);
                              }}
                            >
                              {/* <Typography variant="subTitle116px" sx={{ color: "#0067FF" }}>
                                {order?.supplier?.name}
                              </Typography> */}
                              <Tooltip title={order?.supplier?.name} arrow>
                                <Typography
                                  variant="subTitle116px"
                                  sx={{
                                    color: "#0067FF",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: 180, // set max width as needed
                                    cursor: "pointer",
                                    display: "inline-block",
                                  }}
                                >
                                  {order?.supplier?.name}
                                </Typography>
                              </Tooltip>
                            </Link>
                          </TableCell>
                          <TableCell
                            sx={{ textAlign: "center", minWidth: "140px" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Tooltip
                                title={`Create time - ${order.created_at.split(" ")[1]}`}
                                arrow
                              >
                                <Typography
                                  variant="subTitle116px"
                                  fontSize="14px"
                                  sx={{
                                    color: "#3A3A3A",
                                    cursor: "pointer", // optional, to indicate hover
                                  }}
                                >
                                  <Typography
                                    variant="subTitle116px"
                                    fontSize={"14px"}
                                    fontWeight={"400"}
                                    sx={{ color: "#3A3A3A" }}
                                  >
                                    {" "}
                                    {formattedDateWithoutBg(
                                      order.created_at.split(" ")[0],
                                    )}{" "}
                                  </Typography>
                                </Typography>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Tooltip
                                title={`Update time - ${order.updated_at.split(" ")[1]}`}
                                arrow
                              >
                                <Typography
                                  variant="subTitle116px"
                                  fontSize="14px"
                                  sx={{
                                    color: "#3A3A3A",
                                    cursor: "pointer", // optional, to indicate hover
                                  }}
                                >
                                  <Typography
                                    variant="subTitle116px"
                                    fontSize={"14px"}
                                    fontWeight={"400"}
                                    sx={{ color: "#3A3A3A" }}
                                  >
                                    {" "}
                                    {formattedDateWithoutBg(
                                      order.updated_at.split(" ")[0],
                                    )}
                                  </Typography>
                                </Typography>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography
                              variant="subTitle116px"
                              fontSize={"14px"}
                              fontWeight={"400"}
                              sx={{ color: "#3A3A3A" }}
                            >
                              {formattedDateWithoutBg(
                                order?.purchase_date,
                              )}{" "}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A", fontSize: "14px" }}
                            >
                              {" "}
                              {order?.grand_total
                                ? `₹ ${" "} ${order?.grand_total}`
                                : ""}{" "}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {order?.bill_type || " "}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {order?.department.name}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {order.bill_number || " "}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {order?.paid || " "}
                            </Typography>
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                              borderTopRightRadius: "20px",
                              borderBottomRightRadius: "20px",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                gap: "8px",
                                justifyContent: "center",
                              }}
                            >
                              <RemoveRedEyeOutlinedIcon
                                onClick={() => {
                                  setDetailsModal(true);
                                  navigate("/pharmacy", { state: order });

                                  setId(order?.id);
                                }}
                                sx={{
                                  backgroundColor: "#0067FF",
                                  p: "4px",
                                  width: "18px",
                                  color: "white",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              />
                              <EditOutlinedIcon
                                onClick={() => {
                                  setEditId(order?.id);
                                  setEditPurchaseOrderModal(true);
                                }}
                                sx={{
                                  backgroundColor: "#FF8D1E",
                                  p: "4px",
                                  width: "18px",
                                  color: "white",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              />
                              <SettingsBackupRestoreOutlinedIcon
                                onClick={() => {
                                  setReturnPurchaseOrder(true);
                                  navigate("/pharmacy", { state: order });
                                }}
                                sx={{
                                  backgroundColor: "#ff6a3df1",
                                  p: "4px",
                                  width: "20px",
                                  color: "#ffffff",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              />
                              <Tooltip
                                title={order?.batch_in_use ? "Cannot delete: some batches are in use" : ""}
                                arrow
                              >
                                <span>
                                  <DeleteForeverOutlinedIcon
                                    onClick={() => {
                                      if (!order?.batch_in_use) {
                                        setDeleteModal(true);
                                        setId(order?.id);
                                      }
                                    }}
                                    sx={{
                                      backgroundColor: order?.batch_in_use ? "#aaa" : "#FF392B",
                                      p: "4px",
                                      width: "18px",
                                      color: "white",
                                      borderRadius: "5px",
                                      cursor: order?.batch_in_use ? "not-allowed" : "pointer",
                                      opacity: order?.batch_in_use ? 0.6 : 1,
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                ) : (
                  <TableRow>
                    <TableCell
                      sx={{
                        textAlign: "center",
                      }}
                      colSpan={15}
                    >
                      <Typography color={"black"} variant="heading2">
                        Data Not Found
                      </Typography>{" "}
                    </TableCell>
                  </TableRow>
                )}
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
          sx={{ zIndex: 10, px: "20px", mb: "5px" }}
        >
          {/* Export icons */}
          <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <Box sx={{ cursor: "pointer" }} onClick={() => generateCSV(purchaseOrderList?.payload?.purchase_orders)}>
              <img src={csv_icon} alt="" width="28px" />
            </Box>
            <Box sx={{ cursor: "pointer" }} onClick={() => handleShowJson(purchaseOrderList?.payload?.purchase_orders)}>
              <img src={json_icon} alt="" />
            </Box>
          </Box>

          {/* Pagination */}
          <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
            <Button
              onClick={handlePrevious}
              disabled={page === 1}
              startIcon={<ArrowBackIcon sx={{ fontSize: "14px" }} />}
              sx={{ fontSize: "12px", textTransform: "none", color: page === 1 ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
            >
              Prev
            </Button>

            {(() => {
              if (totalPage <= 7) return [...Array(totalPage)].map((_, i) => i + 1);
              const pages = [];
              pages.push(1);
              if (page > 3) pages.push("...");
              for (let p = Math.max(2, page - 1); p <= Math.min(totalPage - 1, page + 1); p++) pages.push(p);
              if (page < totalPage - 2) pages.push("...");
              pages.push(totalPage);
              return pages;
            })().map((p, i) =>
              p === "..." ? (
                <Typography key={`ellipsis-${i}`} sx={{ fontSize: "12px", px: "4px", color: "#999" }}>…</Typography>
              ) : (
                <Button
                  key={p}
                  onClick={() => setPage(p)}
                  sx={{
                    minWidth: "30px", height: "30px", fontSize: "12px", borderRadius: "6px", p: "2px",
                    color: page === p ? "#fff" : "#333",
                    backgroundColor: page === p ? "#007A99" : "#fff",
                    border: "1px solid #d0d0d0",
                    "&:hover": { backgroundColor: page === p ? "#007A99" : "#f2f2f2" },
                  }}
                >
                  {p}
                </Button>
              )
            )}

            <Button
              onClick={handleNext}
              disabled={page === totalPage || totalPage === 0}
              endIcon={<ArrowForwardIcon sx={{ fontSize: "14px" }} />}
              sx={{ fontSize: "12px", textTransform: "none", color: (page === totalPage || totalPage === 0) ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
            >
              Next
            </Button>

            <Box display="flex" alignItems="center" gap="4px">
              <Typography sx={{ fontSize: "12px", color: "#555" }}>Go to</Typography>
              <TextField
                size="small"
                type="number"
                value={goToPage}
                onChange={(e) => setGoToPage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const n = parseInt(goToPage, 10);
                    if (n >= 1 && n <= totalPage) { setPage(n); setGoToPage(""); }
                  }
                }}
                sx={{ width: "60px", "& input": { fontSize: "12px", padding: "6px 8px" }, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
              />
            </Box>

            <FormControl size="small" sx={{ minWidth: 80 }}>
              <InputLabel sx={{ fontSize: "12px" }}>Rows</InputLabel>
              <Select
                value={itemPerPage}
                label="Rows"
                onChange={(e) => { setItemPerPage(e.target.value); setPage(1); }}
                sx={{ fontSize: "12px", borderRadius: "8px" }}
              >
                {[10, 20, 50, 100].map((n) => (
                  <MenuItem key={n} value={n} sx={{ fontSize: "12px" }}>{n}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={detailsModal}
        setDetailsModal
        onClose={() => setDetailsModal(false)}
      >
        <PurchaseOrderDetails
          onClose={() => setDetailsModal(false)}
          id={id}
          refetch={refetch}
          page={page}
          itemPerPage={itemPerPage}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "96%" }}
        open={editPurchaseOrderModal}
        onClose={() => setEditPurchaseOrderModal(false)}
      >
        <EditPurchaseOrder
          onClose={() => setEditPurchaseOrderModal(false)}
          refetch={refetch}
          id={editId}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "96%" }}
        open={newPurchaseOrderModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return; // ✅ outside click ignored
          setNewPurchaseOrderModal(false);
        }}
      >
        <NewPurchaseOrder
          onClose={() => setNewPurchaseOrderModal(false)}
          refetch={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "96%" }}
        open={returnPurchaseOrder}
        onClose={() => setReturnPurchaseOrder(false)}
      >
        <ReturnPurchaseOrder
          onClose={() => setReturnPurchaseOrder(false)}
          refetch={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "92%" }}
        open={supperDetailsModal}
        onClose={() => setSupperDetailsModal(false)}
      >
        <SupplierDetails
          onClose={() => setSupperDetailsModal(false)}
          id={SupplierId}
          refetch={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "92%" }}
        open={puchaseOrderScanFile}
        onClose={() => setPuchaseOrderScanFile(false)}
      >
        <AddPucharaseOrderFileScan
          onClose={() => setPuchaseOrderScanFile(false)}
          id={SupplierId}
          refetch={refetch}
        />
      </CustomModal>
    </>
  );
};

export default PurchaseOrder;
